import moment from 'moment';
import { inRange, groupBy, difference } from 'lodash';
import React from 'react';
import { ELSLoggingService } from 'components/common';
import { ASSIGNMENT_DUE_MENU_NEXT_7_DAYS, ASSIGNMENT_DUE_MENU_LAST_30_DAYS, ASSIGNMENT_DUE_MENU_LAST_7_DAYS, ASSIGNMENT_DUE_MENU_NEXT_14_DAYS, ASSIGNMENT_DUE_NEW_MENU_OPTIONS, ASSIGNMENT_DUE_MENU_SEMESTER } from 'reports/cw/constants/cw.constant';
import { ASSIGNMENT_TYPES, REPORT_DEPENDENT_OPTIONS as dependentList, VALUE_NA } from 'reports/cw/constants/report.constant';
import { convertQuizTypeToType, getHiddenDependentOption } from 'reports/cw/helpers/report.helper';
import { asTimestringFormated } from 'reports/cw/services/report.service';
import { GradeType } from 'reports/cw/models';
export var renderAvgTimeSpent = function (_a) {
    var avgTimeSpent = _a.avgTimeSpent;
    if (!avgTimeSpent) {
        return <span>{VALUE_NA}</span>;
    }
    return <span>{asTimestringFormated(avgTimeSpent)}</span>;
};
function isStudentHomeReportMetric(assignment) {
    var asm = assignment;
    return asm.gradeType !== undefined;
}
function isStudentDetailAssignment(assignment) {
    var asm = assignment;
    return asm.contentType !== undefined;
}
function isAssignmentEngagementMetricDTO(assignment) {
    var asm = assignment;
    return asm.assignmentType !== undefined && asm.assignmentGradeType !== undefined;
}
export var getAssignmentCountByType = function (assignments, assignmentType) {
    var _a;
    var dependentOptions = ((_a = dependentList.find(function (item) { return item.parentOption === assignmentType; })) === null || _a === void 0 ? void 0 : _a.dependentOptionlist) || [];
    return assignments.filter(function (asm) {
        if (isStudentDetailAssignment(asm)) {
            return asm.contentType === assignmentType || (dependentOptions === null || dependentOptions === void 0 ? void 0 : dependentOptions.includes(asm.contentType));
        }
        return asm.assignmentType === assignmentType || dependentOptions.includes(asm.assignmentType);
    }).length;
};
export var buildAssignmentTypeMenu = function (assignments, assignmentTypes) {
    return assignmentTypes.map(function (type) {
        var _a;
        return {
            key: type,
            name: "".concat((_a = convertQuizTypeToType(type)) === null || _a === void 0 ? void 0 : _a.name, " (").concat(getAssignmentCountByType(assignments, type), ")")
        };
    });
};
export var buildAssignmentDueMenu = function (assignments) {
    if (assignments === void 0) { assignments = []; }
    var allName = "all (".concat(assignments.length, ")");
    return ASSIGNMENT_DUE_NEW_MENU_OPTIONS.map(function (option) {
        if (option.key === ASSIGNMENT_DUE_MENU_SEMESTER.key) {
            return {
                key: option.key,
                name: allName,
                value: option.value
            };
        }
        return option;
    });
};
export var getAssignmentTypes = function (assignments) {
    if (assignments === void 0) { assignments = []; }
    var validTypes = Object.values(ASSIGNMENT_TYPES).map(function (assignmentType) { return assignmentType.id; });
    var allAssignmentTypes = Object.keys(groupBy(assignments, 'assignmentType'));
    var invalidTypes = difference(allAssignmentTypes, validTypes).join();
    if (invalidTypes.length) {
        ELSLoggingService.error('getAssignmentTypes', "ASSIGNMENT TYPE NOT FOUND: ".concat(invalidTypes));
    }
    return allAssignmentTypes.filter(function (assignmentType) { return validTypes.includes(assignmentType); });
};
export var getContentTypes = function (assignments) {
    if (assignments === void 0) { assignments = []; }
    var validTypes = Object.values(ASSIGNMENT_TYPES).map(function (assignmentType) { return assignmentType.id; });
    var allAssignmentTypes = Object.keys(groupBy(assignments, 'contentType'));
    var invalidTypes = difference(allAssignmentTypes, validTypes).join();
    if (invalidTypes.length) {
        ELSLoggingService.error('getContentTypes', "CONTENT TYPE NOT FOUND: ".concat(invalidTypes));
    }
    return allAssignmentTypes.filter(function (assignmentType) { return validTypes.includes(assignmentType); });
};
export var renderAssignmentTypeMenuLabel = function (displayAssignments, _a) {
    var checkedKeys = _a.checkedKeys, assignmentTypeMenuOptions = _a.assignmentTypeMenuOptions;
    var hideList = getHiddenDependentOption(dependentList === null || dependentList === void 0 ? void 0 : dependentList.flatMap(function (option) { return option.dependentOptionlist; }), assignmentTypeMenuOptions);
    if (checkedKeys.length === assignmentTypeMenuOptions.length) {
        return "All (".concat(displayAssignments.length, ")");
    }
    var sortedCheckedKeys = checkedKeys.sort(function (k1, k2) { var _a, _b; return (_a = convertQuizTypeToType(k1)) === null || _a === void 0 ? void 0 : _a.name.localeCompare((_b = convertQuizTypeToType(k2)) === null || _b === void 0 ? void 0 : _b.name); });
    var filteredCheckedKeys = sortedCheckedKeys.filter(function (type) { return !hideList.includes(type); });
    return filteredCheckedKeys
        .map(function (type) {
        var _a;
        return "".concat((_a = convertQuizTypeToType(type)) === null || _a === void 0 ? void 0 : _a.name, " (").concat(getAssignmentCountByType(displayAssignments, type), ")");
    })
        .filter(Boolean)
        .join(', ');
};
export var filterAssignmentByName = function (assignments, name) {
    return (assignments || []).filter(function (assignment) {
        var _a, _b;
        if (isStudentDetailAssignment(assignment)) {
            return (_a = assignment.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim().includes(name === null || name === void 0 ? void 0 : name.toLowerCase().trim());
        }
        if (isStudentHomeReportMetric(assignment) || isAssignmentEngagementMetricDTO(assignment)) {
            return (_b = assignment.assignmentName) === null || _b === void 0 ? void 0 : _b.toLowerCase().trim().includes(name === null || name === void 0 ? void 0 : name.toLowerCase().trim());
        }
        return false;
    });
};
export var filterAssignmentByCheckKeys = function (assignments, assignmentTypeMenuCheckedKeys) {
    return assignments.filter(function (assignment) {
        if (isStudentDetailAssignment(assignment)) {
            return assignmentTypeMenuCheckedKeys.includes(assignment.contentType);
        }
        if (isStudentHomeReportMetric(assignment) || isAssignmentEngagementMetricDTO(assignment)) {
            return assignmentTypeMenuCheckedKeys.includes(assignment.assignmentType);
        }
        return false;
    });
};
export var filterAssignmentByRangeDate = function (assignments, assignmentDueMenuCheckedKey, menuOptions) {
    switch (assignmentDueMenuCheckedKey) {
        case ASSIGNMENT_DUE_MENU_LAST_7_DAYS.key:
            return assignments.filter(function (assignment) {
                return moment(assignment.dueDate).isBetween(moment()
                    .subtract(ASSIGNMENT_DUE_MENU_LAST_7_DAYS.value, 'days')
                    .startOf('day'), moment().startOf('day'));
            });
        case ASSIGNMENT_DUE_MENU_NEXT_7_DAYS.key:
            return assignments.filter(function (assignment) {
                return moment(assignment.dueDate).isBetween(moment().startOf('day'), moment()
                    .add(ASSIGNMENT_DUE_MENU_NEXT_7_DAYS.value, 'days')
                    .startOf('day'));
            });
        case ASSIGNMENT_DUE_MENU_LAST_30_DAYS.key:
            return assignments.filter(function (assignment) {
                return inRange(moment()
                    .startOf('day')
                    .diff(moment(assignment.dueDate).startOf('day'), 'days'), ASSIGNMENT_DUE_MENU_LAST_30_DAYS.value + 1);
            });
        case ASSIGNMENT_DUE_MENU_NEXT_14_DAYS.key:
            return assignments.filter(function (assignment) {
                return moment(assignment.dueDate).isBetween(moment().startOf('day'), moment()
                    .add(ASSIGNMENT_DUE_MENU_NEXT_14_DAYS.value, 'days')
                    .startOf('day'));
            });
        default:
            return assignments;
    }
};
export var filterAssignmentByGradedOnly = function (assignments, filteredByGradeOnly) {
    if (filteredByGradeOnly)
        return assignments.filter(function (assignment) {
            if (isStudentDetailAssignment(assignment) || isStudentHomeReportMetric(assignment)) {
                return assignment.gradeType !== GradeType.NOT_GRADED.valueOf();
            }
            if (isAssignmentEngagementMetricDTO(assignment)) {
                return assignment.assignmentGradeType !== GradeType.NOT_GRADED.valueOf();
            }
            return true;
        });
    return assignments;
};
export var getFilteredAssignmentData = function (assignments, filter) {
    var searchKeyword = filter.searchKeyword, assignmentTypeMenuCheckedKeys = filter.assignmentTypeMenuCheckedKeys, assignmentDueMenuCheckedKey = filter.assignmentDueMenuCheckedKey, filteredGradedOnly = filter.filteredGradedOnly;
    var assignmentByName = filterAssignmentByName(assignments, searchKeyword);
    var assignmentsByDate = filterAssignmentByRangeDate(assignmentByName, assignmentDueMenuCheckedKey);
    var assignmentByGradedOnly = filterAssignmentByGradedOnly(assignmentsByDate, filteredGradedOnly);
    var displayAssignments = filterAssignmentByCheckKeys(assignmentByGradedOnly, assignmentTypeMenuCheckedKeys);
    return {
        displayAssignments: displayAssignments,
        assignmentsByDate: assignmentsByDate,
        assignmentByGradedOnly: assignmentByGradedOnly
    };
};
export var getInteractiveReviewBody = function (courseSectionInfo, catalog, assignments, assignmentId) {
    var _a;
    var foundAssignment = assignments === null || assignments === void 0 ? void 0 : assignments.find(function (a) { return (a === null || a === void 0 ? void 0 : a.id) === assignmentId; });
    var resource = (_a = catalog === null || catalog === void 0 ? void 0 : catalog.data) === null || _a === void 0 ? void 0 : _a.find(function (c) { var _a; return ((_a = c === null || c === void 0 ? void 0 : c.attributes) === null || _a === void 0 ? void 0 : _a.contentId) === (foundAssignment === null || foundAssignment === void 0 ? void 0 : foundAssignment.contentId); });
    return {
        courseEntitlements: courseSectionInfo.entitlements,
        catalogItem: resource,
        courseSectionId: courseSectionInfo.id
    };
};
